import { useMemo } from "react"
import { useSelector } from "react-redux"
import { PAYE_PAR_CLIENT } from "../components/atelier/AtelierLigneV2"
import { estPerte } from "../utilities/transactionsV2"

export const useMoyenPaiementFacture = () => {
	const { moyenPaiements } = useSelector((state) => state.autreInfo)
	return moyenPaiements.find((mp) => mp.nom === "Facture")
}

// Robustes aux doublons du référentiel des moyens de paiement : on résout le
// moyen de LA transaction par id et on compare le NOM — jamais l'id du premier
// « Facture » de la liste.
export const transactionEstFacture = (t, moyenPaiements) => {
	if (estPerte(t)) return false
	const m = moyenPaiements.find((mp) => mp.id === t.moyenPaie)
	return !!m && m.nom === "Facture"
}

export const moyenFacturePresent = (moyenPaiements) =>
	moyenPaiements.some((m) => m.nom === "Facture")

const MODULE_FLAG = { dep: "showDep", ate: "showAte", loc: "showLoc" }

export function filtrerMoyensPaiement(
	moyenPaiements,
	{ module, entite, payeParSelect, valeurCourante },
) {
	const flag = MODULE_FLAG[module]
	return moyenPaiements.filter((mp) => {
		if (mp.id === valeurCourante) return true
		if (flag && !mp[flag]) return false
		if (
			mp.nom === "Facture" &&
			payeParSelect === PAYE_PAR_CLIENT &&
			entite &&
			entite.id > 0 &&
			entite.can_payer_par_facture === false
		)
			return false
		return true
	})
}

export function useMoyensPaiementPour({
	module,
	entite,
	payeParSelect,
	valeurCourante,
}) {
	const { moyenPaiements } = useSelector((state) => state.autreInfo)
	return useMemo(
		() =>
			filtrerMoyensPaiement(moyenPaiements, {
				module,
				entite,
				payeParSelect,
				valeurCourante,
			}),
		[moyenPaiements, module, entite, payeParSelect, valeurCourante],
	)
}
